import type { MediaUrl } from '@setplex/tria-api'

import { ScheduleType, VideoType } from '@setplex/tria-api'
import {
  REWIND_TYPES_EVENT,
  REWIND_TYPES_WITH_EPG,
  REWIND_TYPES_WITHOUT_EPG,
  RewindTypes,
} from '~/shared/constants/rewind'

// export const getStartTime = (startTime: number, maxTime: number) => {
//   const currentTimeSEC = getCurrentTimeSEC()
//   const timeInterval = currentTimeSEC - startTime
//   return timeInterval > 0 && timeInterval > maxTime
//     ? currentTimeSEC - maxTime
//     : startTime
// }

export const chooseRewind = ({
  liveRewindOptions,
  scheduleType,
  contentType,
}: {
  liveRewindOptions?: MediaUrl['liveRewindOptions']
  scheduleType?: ScheduleType
  contentType: VideoType
}): RewindTypes | undefined => {
  if (!scheduleType) return

  if (!liveRewindOptions) return RewindTypes.dvr // fallback

  switch (contentType) {
    case VideoType.CHANNEL: {
      const hasEpg = scheduleType === ScheduleType.EPG

      if (hasEpg) {
        return REWIND_TYPES_WITH_EPG.find((type) => liveRewindOptions[type])
      } else {
        // !hasEpg
        return REWIND_TYPES_WITHOUT_EPG.find((type) => liveRewindOptions[type])
      }
    }
    case VideoType.EVENT: {
      return REWIND_TYPES_EVENT.find((type) => liveRewindOptions[type])
    }
  }
}
